import React, { createContext } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

import { getConfig } from "./config";
import { Auth0Provider } from "@auth0/auth0-react";
import { CookiesProvider } from "react-cookie";
import DefaultLayout from "./layout/default";
import SnackbarProvider from "react-simple-snackbar";
import ErrorBoundary from "./components/ErrorBoundary";
import logger from "./utils/logger";
const config = getConfig();

// --- Global error handlers ---

window.onerror = (
  message: string | Event,
  source?: string,
  lineno?: number,
  colno?: number,
  error?: Error,
): void => {
  logger.error('Uncaught global error', {
    source,
    lineno,
    colno,
  }, error || message);
};

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  logger.error('Unhandled promise rejection', {}, event.reason);
});

// --- End global error handlers ---

const providerConfig = {
    domain: config.domain,
    clientId: config.clientId,
    // onRedirectCallback,
    authorizationParams: {
        redirect_uri: window.location.origin + "/dashboard",
        // ...(config.audience ? { audience: config.audience } : null),
    },
};

if (process.env.NODE_ENV !== "production") {
    logger.info("Auth0 Debug authorize config", {
        domain: providerConfig.domain,
        clientId: providerConfig.clientId,
        authorizationParams: providerConfig.authorizationParams,
    });
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <ErrorBoundary>
    <Auth0Provider {...providerConfig}>
        {/* <React.StrictMode> */}
        <CookiesProvider>
            <BrowserRouter>
                {/* <DefaultLayout> */}
                <SnackbarProvider>
                    <App />
                </SnackbarProvider>
                {/* </DefaultLayout> */}
            </BrowserRouter>
        </CookiesProvider>
        {/* </React.StrictMode> */}
    </Auth0Provider>
    </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
